import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import PatientsTable from "../../components/Patient/PatientsTable";
import CSVImportModal from "../../components/CSVImportModal";
import { Link } from "react-router-dom";
import "./PatientsPage.css";

const PatientsPage = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const downloadTimeoutRef = useRef(null);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleRefresh = () => setRefreshData((prev) => prev + 1);

  useEffect(() => {
    console.log("Selected Patients:", selectedIds);
  }, [selectedIds]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showDownloadDropdown && !event.target.closest('.download-dropdown-container')) {
        setShowDownloadDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDownloadDropdown]);

  const handleDownload = (onlyCsv) => {
    if (selectedIds.length === 0) {
      alert("Please select at least one patient to download");
      return;
    }
    if (downloadInProgress) {
      return;
    }
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
    }
    
    downloadTimeoutRef.current = setTimeout(async () => {
      setDownloadInProgress(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/patients/download`,
          {
            params: { 
              id: selectedIds.join(","),
              onlyCsv: onlyCsv
            },
            headers: { Authorization: `Token ${token}` },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        
        const timestamp = new Date().toISOString().replace(/[:.]/g, "").substring(0, 15);
        const filename = onlyCsv ? `patients_${timestamp}.csv` : `patients_${timestamp}.zip`;
        link.setAttribute("download", filename);
        
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading patients:", error);
        alert("Error downloading patients. Please try again.");
      }
      setDownloadInProgress(false);
      setShowDownloadDropdown(false);
    }, 300);
  };

  return (
    <div className="patients-page">
      <Navbar />
      <div className="patients-content">
        <div className="header-section">
          <h2>Patients</h2>
          <div className="button-group">
            <Link to="/patients/create" className="create-btn">
              New Patient
            </Link>
            <button className="csv-import-btn" onClick={openModal}>
              CSV Import
            </button>
            
            <div className="download-dropdown-container">
              <button
                className="download-btn"
                onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}
                disabled={selectedIds.length === 0 || downloadInProgress}
              >
                Download Selected ({selectedIds.length}) ▼
              </button>
              
              {showDownloadDropdown && (
                <div className="download-dropdown-menu">
                  <button 
                    onClick={() => handleDownload(true)}
                    disabled={downloadInProgress}
                  >
                    Download CSV
                  </button>
                  <button 
                    onClick={() => handleDownload(false)}
                    disabled={downloadInProgress}
                  >
                    Download All Data
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <PatientsTable refreshData={refreshData} onSelectedIdsChange={setSelectedIds} />
      </div>

      <CSVImportModal
        type={"patients"}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={() => {
          handleRefresh();
          closeModal();
        }}
      />
    </div>
  );
};

export default PatientsPage;
